// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"183":"34b51f5d","350":"6abcb78b","768":"6fc557eb","817":"a15e6235"}[chunkId] + ".css";
};